import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SearchBar from '../components/SearchBar/SearchBar';
import { API } from '../data/API/API';
import MemberTable from '../components/MemberTable/MemberTable';
import { Modal, Spinner, FormControl } from 'react-bootstrap'; // Import Modal and other components
import './ContactMembersPage.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faEdit, faTimes, faPaperPlane, faCheck, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import EmailTemplateRadioButtons from '../components/EmailTemplateRadioButtons/EmailTemplateRadioButtons';
import RTE from '../components/RTE/RTE'; // Import for rich text editor
import MonthPicker from '../components/DatePicker/MonthPicker';
import { format } from 'date-fns'; // Import date formatting
import { FaSquare, FaCheckSquare } from 'react-icons/fa'; // Import icons for custom checkbox
import { ManualMembers } from "../data/API/ManualMembers";
import ManualMemberTable, { ManualMemberRow } from "../components/MemberTable/ManualMemberTable";
import { Nav } from "react-bootstrap";
import { ManulMembersModal } from '../components/Modals/ManualMembersModal';
import { S1GO_Customer } from '../data/API/Suppliers';

interface Member {
    selected: boolean;
    customerOrgId: string;
    customerName: string;
    contactPerson: string;
    lastReviewed: string;
}

interface EmailTemplate {
    id: number;
    templateName: string;
    header: string;
    body: string;
    active: boolean; // Add this field
}
type ReviewMethod = "email" | "phone";
type MemberTab = "members" | "manual";
const ContactMembersPage: React.FC = () => {

const [reviewMethod, setReviewMethod] = useState<ReviewMethod>("email");
const [showPhoneConfirmModal, setShowPhoneConfirmModal] = useState(false);
const [isCreatingPhoneReviews, setIsCreatingPhoneReviews] = useState(false);
const [showPhoneSuccessModal, setShowPhoneSuccessModal] = useState(false);
const [phoneErrorModalVisible, setPhoneErrorModalVisible] = useState(false);
const [activeTab, setActiveTab] = useState<MemberTab>("members");
const [manualMemberData, setManualMemberData] = useState<ManualMemberRow[]>([]);
const [manualLoading, setManualLoading] = useState(false);
const [s1GoCustomers,setS1GoCustomers] = useState<S1GO_Customer[]>([]);
const [showAddManualModal, setShowAddManualModal] = useState(false);
const [newManualOrgId, setNewManualOrgId] = useState("");
const [newManualName, setNewManualName] = useState("");
const [newManualEmail, setNewManualEmail] = useState("");
const [addManualSaving, setAddManualSaving] = useState(false);
const [addManualError, setAddManualError] = useState<string | null>(null);

    /*Slut nytt*/
    const location = useLocation();
    const navigate = useNavigate();
    const { orgNr, supplierName, selectedDate } = location.state || {}; // Access passed data

    const [memberData, setMemberData] = useState<Member[]>([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [isSelectingTemplate, setIsSelectingTemplate] = useState(false);
    const [isFinalStep, setIsFinalStep] = useState(false);
    const [isEditable, setIsEditable] = useState(false); // New state to toggle email editing
    const [selectedMembers, setSelectedMembers] = useState<Member[]>([]);
    const [selectedTemplate, setSelectedTemplate] = useState<EmailTemplate | null>(null);
    const [emailSubject, setEmailSubject] = useState('');
    const [emailBody, setEmailBody] = useState('');
    const [showConfirmModal, setShowConfirmModal] = useState(false); // Confirmation modal state for sending emails
    const [showResetConfirmModal, setShowResetConfirmModal] = useState(false); // New state for reset confirmation
    const [showSuccessModal, setShowSuccessModal] = useState(false); // Success modal state
    const [isSendingEmails, setIsSendingEmails] = useState(false); // New state for email sending
    const [isAllSelected, setIsAllSelected] = useState(false);

    // States for original data
    const [originalMemberData, setOriginalMemberData] = useState<Member[]>([]);
    const [originalSelectedMembers, setOriginalSelectedMembers] = useState<Member[]>([]); // Store original selected members
    const [originalEmailSubject, setOriginalEmailSubject] = useState(''); // Store original email subject
    const [originalEmailBody, setOriginalEmailBody] = useState(''); // Store original email body
    const [errorModalVisible, setErrorModalVisible] = useState(false); // New state for error modal
    // Set initial dates based on selectedDate or default to the current date if not provided
    const [startDate, setStartDate] = useState<Date>(selectedDate ? new Date(selectedDate) : new Date());
    const [endDate, setEndDate] = useState<Date>(selectedDate ? new Date(selectedDate) : new Date());

    const [showDateModal, setShowDateModal] = useState(false);

    // Temporary states for the modal
    const [tempStartDate, setTempStartDate] = useState<Date>(selectedDate ? new Date(selectedDate) : new Date());
    const [tempEndDate, setTempEndDate] = useState<Date>(selectedDate ? new Date(selectedDate) : new Date());

    const [extendPeriod, setExtendPeriod] = useState(false); // Checkbox state
    const [extraMonths, setExtraMonths] = useState<number>(0); // Dropdown state for additional months
    useEffect(() => {
  const fetchManualMembers = async () => {
    if (!orgNr) return;
    setManualLoading(true);
    try {
      const res = await ManualMembers.getForSupplier(orgNr);
      const rows: ManualMemberRow[] = res.map((m) => ({
        selected: false,
        customerOrgId: m.customerOrgId,
        customerName: m.customerName,
        contactPerson: m.contactPerson,
        lastReviewed: m.lastReviewed,
      }));
      setManualMemberData(rows);

      // Tabs bara om manuella finns, annars håll "members"
      if (rows.length === 0) setActiveTab("members");
    } finally {
      setManualLoading(false);
    }
  };

  fetchManualMembers();
}, [orgNr]);

    useEffect(() => {
        const fetchMembers = async () => {
            setLoading(true);
            try {
                const startDateAdjusted = new Date(startDate);
                if (extendPeriod && extraMonths > 0) {
                    startDateAdjusted.setMonth(startDateAdjusted.getMonth() - extraMonths);
                }

                const formattedStartDate = startDateAdjusted.toISOString().slice(0, 7);
                const formattedEndDate = endDate.toISOString().slice(0, 7);
                const getAllMember = await API.Suppliers.GetAllMembers();
                const getLastContacted = await API.Suppliers.GetLastContactedCustomMember(`${orgNr}`);
                const response = await API.Suppliers.GetMembersBySupplierOrgIdAndDate(
                    orgNr,
                    formattedStartDate,
                    formattedEndDate
                );

                const members = response.map((member: { customerOrgId: string, customerName: string, contactPerson: string, lastReviewed: string }) => ({
                    selected: false,
                    customerOrgId: member.customerOrgId,
                    customerName: member.customerName,
                    contactPerson: member.contactPerson,
                    lastReviewed: member.lastReviewed,
                }))
                setS1GoCustomers(getAllMember);
                setMemberData(members);
                setOriginalMemberData(members);
            } catch (error) {
                console.error('Failed to fetch member data:', error);
            } finally {
                setLoading(false);
            }
        };

        if (orgNr && startDate && endDate) {
            fetchMembers();
        }
    }, [orgNr, startDate, endDate, extendPeriod, extraMonths]);


    function decodeHTMLEntities(text: string): string {
        const textArea = document.createElement("textarea");
        textArea.innerHTML = text;
        return textArea.value;
    }

    useEffect(() => {
        if (selectedTemplate) {
            setEmailSubject(selectedTemplate.header);  // Set subject from selected template
            setOriginalEmailSubject(selectedTemplate.header);  // Store original subject

            const decodedBody = decodeHTMLEntities(selectedTemplate.body);  // Decode the HTML entities
            setEmailBody(decodedBody);  // Set the decoded body to the state
            setOriginalEmailBody(decodedBody);  // Store original body
        }
    }, [selectedTemplate]);

    // Handle checkbox toggle
    // const handleCheckboxChange = (orgId: string) => {
    //     const updatedMembers = memberData.map(member =>
    //         member.customerOrgId === orgId ? { ...member, selected: !member.selected } : member
    //     );

    //     // Update the selection state for members
    //     setMemberData(updatedMembers);

    //     // Check if all members are selected, and update the "Select All" state
    //     const areAllMembersSelected = updatedMembers.every(member => member.selected);
    //     setIsAllSelected(areAllMembersSelected);
    // };
    const handleCheckboxChange = (orgId: string) => {
  if (activeTab === "manual") {
    const updated = manualMemberData.map((m) =>
      m.customerOrgId === orgId ? { ...m, selected: !m.selected } : m
    );
    setManualMemberData(updated);
    const areAllSelected = updated.length > 0 && updated.every((m) => m.selected);
    setIsAllSelected(areAllSelected);
    return;
  }

  const updatedMembers = memberData.map((member) =>
    member.customerOrgId === orgId ? { ...member, selected: !member.selected } : member
  );

  setMemberData(updatedMembers);
  const areAllMembersSelected = updatedMembers.length > 0 && updatedMembers.every((m) => m.selected);
  setIsAllSelected(areAllMembersSelected);
};


    // Handle contact person email change
    // const handleContactPersonChange = (orgId: string, newEmail: string) => {
    //     // Update both memberData and selectedMembers
    //     const updatedMembers = memberData.map(member =>
    //         member.customerOrgId === orgId ? { ...member, contactPerson: newEmail } : member
    //     );
    //     const updatedSelectedMembers = selectedMembers.map(member =>
    //         member.customerOrgId === orgId ? { ...member, contactPerson: newEmail } : member
    //     );

    //     // Set updated members back to both states
    //     setMemberData(updatedMembers);
    //     setSelectedMembers(updatedSelectedMembers);
    // };
    const handleContactPersonChange = (orgId: string, newEmail: string) => {
  setMemberData((prev) =>
    prev.map((m) => (m.customerOrgId === orgId ? { ...m, contactPerson: newEmail } : m))
  );

  setManualMemberData((prev) =>
    prev.map((m) => (m.customerOrgId === orgId ? { ...m, contactPerson: newEmail } : m))
  );

  setSelectedMembers((prev) =>
    prev.map((m) => (m.customerOrgId === orgId ? { ...m, contactPerson: newEmail } : m))
  );
};
const handleManualLocalChange = (orgId: string, patch: Partial<Pick<ManualMemberRow, "customerName" | "contactPerson">>) => {
  setManualMemberData((prev) => prev.map((m) => (m.customerOrgId === orgId ? { ...m, ...patch } : m)));
  setSelectedMembers((prev) => prev.map((m) => (m.customerOrgId === orgId ? { ...m, ...patch } : m)));
};

const handleManualUpdate = async (customerOrgId: string, payload: { customerName: string; contactPerson: string }) => {
  if (!orgNr) return false;
  const updated = await ManualMembers.update(orgNr, customerOrgId, payload);
  if (!updated) return false;

  setManualMemberData((prev) =>
    prev.map((m) =>
      m.customerOrgId === customerOrgId ? { ...m, customerName: updated.customerName, contactPerson: updated.contactPerson } : m
    )
  );

  setSelectedMembers((prev) =>
    prev.map((m) =>
      m.customerOrgId === customerOrgId ? { ...m, customerName: updated.customerName, contactPerson: updated.contactPerson } : m
    )
  );

  return true;
};

const handleManualDelete = async (customerOrgId: string) => {
  if (!orgNr) return false;
  const ok = await ManualMembers.remove(orgNr, customerOrgId);
  if (!ok) return false;

  setManualMemberData((prev) => prev.filter((m) => m.customerOrgId !== customerOrgId));
  setSelectedMembers((prev) => prev.filter((m) => m.customerOrgId !== customerOrgId));
  return true;
};
const submitAddManual = async () => {
  if (!orgNr) return;

  setAddManualError(null);
  setAddManualSaving(true);
  try {
    const created = await ManualMembers.create(orgNr, {
      customerOrgId: newManualOrgId.trim(),
      customerName: newManualName.trim(),
      contactPerson: newManualEmail.trim(),
    });

    if (!created) {
      setAddManualError("Kunde inte skapa företag. Kontrollera att det inte är en dubblett och att e-post är giltig.");
      return;
    }

    setManualMemberData((prev) => [
      {
        selected: false,
        customerOrgId: created.customerOrgId,
        customerName: created.customerName,
        contactPerson: created.contactPerson,
        lastReviewed: created.lastReviewed,
      },
      ...prev,
    ]);

    setShowAddManualModal(false);
    setNewManualOrgId("");
    setNewManualName("");
    setNewManualEmail("");
    setActiveTab("manual"); // visa direkt
  } finally {
    setAddManualSaving(false);
  }
};



//     const handleConfirmSelection = () => {
//   const selectedFromMembers = memberData.filter((m) => m.selected);
//   const selectedFromManual = manualMemberData.filter((m) => m.selected);

//   const union = [...selectedFromMembers, ...selectedFromManual];
//   setSelectedMembers(union);
//   setOriginalSelectedMembers(union);
//   setIsSelectingTemplate(true);
// };
const handleConfirmSelection = () => {
  const selectedFromMembers = memberData.filter((m) => m.selected);
  const selectedFromManual = manualMemberData.filter((m) => m.selected);

  const union = [...selectedFromMembers, ...selectedFromManual];
  setSelectedMembers(union);
  setOriginalSelectedMembers(union);

  if (reviewMethod === "email") {
    setIsSelectingTemplate(true);
    return;
  }

  // Telefonflöde går direkt till sista steget
  setIsFinalStep(true);
};


    // Handle confirming email template selection
    const handleConfirmTemplate = (template: EmailTemplate) => {
        setSelectedTemplate(template);
    };

    // Handle confirming the template and moving to the final step
    const handleConfirmTemplateSelection = () => {
        if (selectedTemplate) {
            setIsFinalStep(true);
        }
    };

    // Handle enabling and disabling edit mode, showing reset confirmation modal if "Återställ" is clicked
    const handleEditEmail = () => {
        if (isEditable) {
            setShowResetConfirmModal(true); // Show the confirmation modal before resetting
        } else {
            setIsEditable(prev => !prev); // Toggle edit mode
        }
    };

    // Handle confirming reset action
    const handleConfirmReset = () => {
        // Reset both memberData and selectedMembers to their original values
        setMemberData(originalMemberData); // Reset all member data
        setSelectedMembers(originalSelectedMembers); // Reset only the selected members

        setEmailSubject(originalEmailSubject); // Reset email subject
        setEmailBody(originalEmailBody); // Reset email body

        setIsEditable(false); // Exit edit mode after reset
        setShowResetConfirmModal(false); // Close reset confirmation modal
    };

    // Handle going back to member selection
    // const handleBackToSelection = () => {
    //     setIsSelectingTemplate(false);
    // };
    const handleBackToSelection = () => {
  setIsSelectingTemplate(false);
  setIsFinalStep(false);
};

    // Handle going back to template selection (from final step)
    const handleBackToTemplateSelection = () => {
        setIsFinalStep(false);
    };

    // Handle opening the confirmation modal for sending emails
    const handleSendEmailsClick = () => {
        setShowConfirmModal(true);
    };
const handleCreatePhoneReviews = async () => {
  if (!selectedMembers.length) return;

  setIsCreatingPhoneReviews(true);

  try {
    const reviews = selectedMembers.map((member) => ({
      supplierOrgNr: orgNr,
      supplierName,
      customerOrgNr: member.customerOrgId,
      customerName: member.customerName,
      contactPerson: member.contactPerson,
      period: format(startDate, "yyyy-MM"),
      endPeriod: format(endDate, "yyyy-MM"),
    }));

    await API.PhoneReviews.createBulk({ reviews });

    setShowPhoneConfirmModal(false);
    setShowPhoneSuccessModal(true);
  } catch (error) {
    console.error("Error creating phone reviews:", error);
    setShowPhoneConfirmModal(false);
    setPhoneErrorModalVisible(true);
  } finally {
    setIsCreatingPhoneReviews(false);
  }
};
    // Handle confirming email send
    const handleConfirmSend = async () => {
        setIsSendingEmails(true); // Set loading state for sending emails
        setShowConfirmModal(true); // Keep the confirm modal up while sending emails

        try {
            if (selectedTemplate && selectedMembers.length > 0) {
                const members = selectedMembers.map(member => ({
                    OrgNr: member.customerOrgId,
                    Email: member.contactPerson
                }));

                const emailRequest = {
                    Subject: emailSubject,
                    Body: emailBody,
                    SupplierOrgNr: orgNr,
                    SupplierName: supplierName,                // Add SupplierName
                    Period: format(startDate, 'yyyy-MM'),       // Start period
                    EndPeriod: format(endDate, 'yyyy-MM'),      // End period
                    EmailTemplateId: selectedTemplate?.id,
                    Members: members
                };


                await API.Emails.sendEmails(emailRequest);
                setShowSuccessModal(true);  // Show success modal if emails sent successfully
            } else {
                alert("Vänligen välj en mall och medlemmar.");
            }
        } catch (error) {
            console.error("Error sending emails:", error);
            setErrorModalVisible(true);  // Show error modal if sending fails
        } finally {
            setIsSendingEmails(false);   // Remove loading state after sending or failure
            setShowConfirmModal(false);  // Close the confirm modal
        }
    };

    // Handle closing and navigating back to ReviewSupplierPage
    const handleClose = () => {
        setShowSuccessModal(false);
        navigate(`/reviewsupplier/${orgNr}`, {
            state: {
                orgNumber: orgNr,
                period: selectedDate
            },
        });
    };

    const handleStartDateChange = (newDate: Date | null) => {
        if (newDate) {
            setTempStartDate(newDate);
        }
        if (tempEndDate && newDate && newDate > tempEndDate) setTempEndDate(newDate);
    };

    const handleEndDateChange = (newDate: Date | null) => {
        if (newDate && tempStartDate && newDate >= tempStartDate) setTempEndDate(newDate);
    };

    const handleConfirmDateChange = () => {
        setStartDate(tempStartDate as Date);
        setEndDate(tempEndDate as Date);
        setShowDateModal(false);
    };

    const handleCancelDateChange = () => {
        setTempStartDate(startDate);
        setTempEndDate(endDate);
        setShowDateModal(false);
    };

    // Checkbox handler
    const handleExtendPeriodChange = () => setExtendPeriod(!extendPeriod);

    // Dropdown handler for selecting additional months
    const handleExtraMonthsChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setExtraMonths(parseInt(event.target.value, 10));
    };

    // Filter member data based on search input
    const filteredMembers = memberData.filter(member =>
        member.customerName.toLowerCase().includes(searchText.toLowerCase()) ||
        member.customerOrgId.includes(searchText)
    );

    // const handleSelectAllChange = () => {
    //     // Toggle the "Select All" state
    //     const newAllSelectedState = !isAllSelected;
    //     setIsAllSelected(newAllSelectedState);

    //     // Update the selection status for each member in the filtered list
    //     const updatedMembers = memberData.map(member => ({
    //         ...member,
    //         selected: newAllSelectedState,
    //     }));
    //     setMemberData(updatedMembers);
    // };
    const handleSelectAllChange = () => {
  const newAllSelectedState = !isAllSelected;
  setIsAllSelected(newAllSelectedState);

  if (activeTab === "manual") {
    setManualMemberData((prev) => prev.map((m) => ({ ...m, selected: newAllSelectedState })));
    return;
  }

  setMemberData((prev) => prev.map((m) => ({ ...m, selected: newAllSelectedState })));
};


const hasManual = manualMemberData.length > 0;
const selectedCount =
  memberData.filter((m) => m.selected).length +
  manualMemberData.filter((m) => m.selected).length;
return (
  <div className="contact-members-page">
    <div
      className="header-row"
      style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
    >
      <h1>
        {supplierName} - {orgNr}
      </h1>
    </div>

    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
      <h5 style={{ marginTop: -10 }}>
        Period för granskning:{" "}
        {startDate && endDate
          ? `${format(startDate, "yyyy-MM")}${startDate !== endDate ? ` till ${format(endDate, "yyyy-MM")}` : ""}`
          : ""}
        <button
          className="btn time-modal-button"
          onClick={() => setShowDateModal(true)}
          disabled={isSelectingTemplate || isFinalStep}
        >
          <FontAwesomeIcon icon={faEdit} className="fa-icon" /> Redigera period
        </button>
      </h5>
    </div>

    <h2>Kontakta medlemmar</h2>

    {!isSelectingTemplate && !isFinalStep ? (
      <>
        <div className="member-search-controls">
          <SearchBar placeholder="Sök.." value={searchText} onChange={setSearchText} />
        </div>

        {/* Show checkbox and dropdown if not in selection or final step */}
        {!isSelectingTemplate && !isFinalStep && (
          <>
            {/* Styled Checkbox to activate period extension */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <div
                className="extend-period-checkbox"
                style={{
                  display: isSelectingTemplate || isFinalStep ? "none" : "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <span onClick={handleExtendPeriodChange} style={{ cursor: "pointer" }}>
                  {extendPeriod ? (
                    <FaCheckSquare className="custom-checkbox checked" />
                  ) : (
                    <FaSquare className="custom-checkbox" />
                  )}
                </span>
                <label>Visa medlemmar från en utökad tidsperiod</label>

                <select
                  value={extraMonths}
                  onChange={handleExtraMonthsChange}
                  disabled={!extendPeriod || isSelectingTemplate || isFinalStep}
                  style={{ marginLeft: "10px" }}
                  className="extend-period-select"
                >
                  <option value="0">Välj månader</option>
                  {[...Array(12)].map((_, i) => (
                    <option key={i} value={i + 1}>
                      {i + 1} månader
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </>
        )}
<div style={{ marginBottom: 16 }}>
  <h3 style={{ marginBottom: 10 }}>Välj granskningstyp</h3>
  <div style={{ display: "flex", gap: 12 }}>
    <button
      type="button"
      className={`btn ${reviewMethod === "email" ? "" : "button-cancel"}`}
      onClick={() => setReviewMethod("email")}
      disabled={isSelectingTemplate || isFinalStep}
    >
      E-postgranskning
    </button>

    <button
      type="button"
      className={`btn ${reviewMethod === "phone" ? "" : "button-cancel"}`}
      onClick={() => setReviewMethod("phone")}
      disabled={isSelectingTemplate || isFinalStep}
    >
      Telefongranskning
    </button>
  </div>
</div>
        <div className="member-selection-header">
          <div>
            <h2>Välj medlemmar</h2>

            <div className="member-selection-header-select-all">
              <span onClick={handleSelectAllChange} style={{ cursor: "pointer" }}>
                {isAllSelected ? (
                  <FaCheckSquare className="custom-checkbox checked" />
                ) : (
                  <FaSquare className="custom-checkbox" />
                )}
              </span>
              <label style={{ cursor: "pointer" }} onClick={handleSelectAllChange}>
                Välj alla medlemmar
              </label>
            </div>
          </div>

          <div className="button-group">
            <button className="btn button-cancel" onClick={() => navigate(-1)}>
              <FontAwesomeIcon icon={faArrowLeft} /> Tillbaka
            </button>

            <button
              className="btn"
              onClick={handleConfirmSelection}
              disabled={
                memberData.every((m) => !m.selected) && manualMemberData.every((m) => !m.selected)
              }
            >
              Bekräfta urval
            </button>
          </div>
        </div>

        {/* Tabs (bara om manuella finns) */}
        {hasManual && (
          <div className='tabStyleOveride' style={{ marginTop: 10, marginBottom: 10 }}>
            <Nav
            
              variant="tabs"
              activeKey={activeTab}
              onSelect={(k) => {
                const key = (k as any) ?? "members";
                setActiveTab(key);
                setIsAllSelected(false);
              }}
            >
              <Nav.Item>
                <Nav.Link eventKey="members">Medlemmar</Nav.Link>
              </Nav.Item>
              <Nav.Item style={{color:'#173c53'}}>
                <Nav.Link eventKey="manual" >Egna företag</Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
        )}

        {/* Add button */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 10 }}>
          <button
            className="btn"
            onClick={() => {
              setAddManualError(null);
              setShowAddManualModal(true);
            }}
            disabled={isSelectingTemplate || isFinalStep}
          >
            Lägg till företag
          </button>
        </div>

        {loading || manualLoading ? (
          <Spinner animation="border" />
        ) : (
          <>
            {!hasManual || activeTab === "members" ? (
              <MemberTable
                memberData={filteredMembers}
                isLoading={loading}
                onCheckboxChange={handleCheckboxChange}
                isEditable={isEditable}
                onContactPersonChange={handleContactPersonChange}
              />
            ) : (
              <ManualMemberTable
                memberData={manualMemberData.filter(
                  (m) =>
                    m.customerName.toLowerCase().includes(searchText.toLowerCase()) ||
                    m.customerOrgId.includes(searchText)
                )}
                isLoading={manualLoading}
                onCheckboxChange={handleCheckboxChange}
                onLocalChange={handleManualLocalChange}
                onUpdate={handleManualUpdate}
                onDelete={handleManualDelete}
              />
            )}
          </>
        )}
      </>
    ) : isSelectingTemplate && !isFinalStep ? (
      <>
        <div className="member-selection-header">
          <h3>Valda medlemmar</h3>
          <button className="btn button-cancel contact-member-button" onClick={handleBackToSelection}>
            <FontAwesomeIcon icon={faArrowLeft} /> Ändra urval
          </button>
        </div>

        <MemberTable
          memberData={selectedMembers}
          isLoading={loading}
          onCheckboxChange={() => {}}
          hideCheckboxes={true}
          isEditable={false}
          onContactPersonChange={() => {}}
        />

        <div className="member-selection-header">
          <h3>Välj en aktiv e-postmall</h3>
          <button
            className="btn contact-member-button"
            onClick={handleConfirmTemplateSelection}
            disabled={!selectedTemplate}
          >
            <FontAwesomeIcon icon={faCheck} /> Bekräfta mall
          </button>
        </div>

        <EmailTemplateRadioButtons onTemplateSelect={handleConfirmTemplate} selectedTemplate={selectedTemplate} />
      </>
   ) : reviewMethod === "email" ? (
  <>
    <div className="member-selection-header">
      <h2 className="header-left">Skriv e-post</h2>
      <div className="button-group">
        <button className="btn button-cancel contact-member-button" onClick={handleBackToTemplateSelection}>
          <FontAwesomeIcon icon={faArrowLeft} /> Ändra mall
        </button>

        <button className="btn contact-member-button" onClick={handleEditEmail}>
          <FontAwesomeIcon icon={isEditable ? faTimes : faEdit} />{" "}
          {isEditable ? "Återställ" : "Redigera epost"}
        </button>

        <button className="btn button-submit contact-member-button" onClick={handleSendEmailsClick}>
          <FontAwesomeIcon icon={faPaperPlane} /> Skicka
        </button>
      </div>
    </div>

    <p style={{ marginTop: "-20px", width: "fit-content" }}>
      <i>Vald mall: {selectedTemplate?.templateName}</i>
    </p>

    <MemberTable
      memberData={selectedMembers}
      isLoading={loading}
      onCheckboxChange={() => {}}
      hideCheckboxes={true}
      isEditable={isEditable}
      onContactPersonChange={handleContactPersonChange}
    />

    {selectedTemplate && (
      <div className="email-template-content">
        <h3 className="mb-3">Ämne</h3>
        <FormControl
          type="text"
          value={emailSubject}
          onChange={(e) => setEmailSubject(e.target.value)}
          disabled={!isEditable}
          className="mb-4"
        />

        <h3 className="mb-3">Innehåll</h3>

        {!isEditable ? (
          <div
            className="email-body-display mb-4"
            style={{
              backgroundColor: "#e9ecef",
              padding: "10px",
              border: "1px solid #ced4da",
              borderRadius: "8px",
              minHeight: "150px",
              whiteSpace: "pre-wrap",
              overflowWrap: "break-word",
            }}
            dangerouslySetInnerHTML={{ __html: emailBody }}
          />
        ) : (
          <RTE value={emailBody} onChange={setEmailBody} />
        )}
      </div>
    )}
  </>
) : (
  <>
    <div className="member-selection-header">
      <h2 className="header-left">Skapa telefongranskningar</h2>
      <div className="button-group">
        <button className="btn button-cancel contact-member-button" onClick={handleBackToSelection}>
          <FontAwesomeIcon icon={faArrowLeft} /> Ändra urval
        </button>

        <button
          className="btn button-submit contact-member-button"
          onClick={() => setShowPhoneConfirmModal(true)}
        >
          <FontAwesomeIcon icon={faCheck} /> Skapa telefongranskningar
        </button>
      </div>
    </div>

    <p style={{ marginTop: "-20px", width: "fit-content" }}>
      <i>
        {selectedMembers.length} kund{selectedMembers.length !== 1 ? "er" : ""} kommer få en telefongranskning
      </i>
    </p>

    <MemberTable
      memberData={selectedMembers}
      isLoading={loading}
      onCheckboxChange={() => {}}
      hideCheckboxes={true}
      isEditable={false}
      onContactPersonChange={() => {}}
    />

    <div
      style={{
        background: "#f6f2ed",
        border: "1px solid #dee2e6",
        borderRadius: 8,
        padding: 16,
        marginTop: 16,
      }}
    >
      <h3 style={{ marginBottom: 12 }}>Sammanfattning</h3>
      <p><b>Leverantör:</b> {supplierName} - {orgNr}</p>
      <p>
        <b>Period:</b> {format(startDate, "yyyy-MM")}
        {startDate !== endDate ? ` till ${format(endDate, "yyyy-MM")}` : ""}
      </p>
      <p><b>Typ:</b> Telefongranskning</p>
      <p><b>Antal ärenden:</b> {selectedMembers.length}</p>
    </div>
  </>
)}

    {/* Add Manual Company Modal */}
    <ManulMembersModal 
    s1GoCustomers={s1GoCustomers}
    newManualEmail={newManualEmail}
    newManualName={newManualName}
    newManualOrgId={newManualOrgId}
    submitAddManual={submitAddManual}
    addManualSaving={addManualSaving}
    addManualError={addManualError}
    showAddManualModal={showAddManualModal}
    setNewManualEmail={setNewManualEmail} 
    setNewManualName={setNewManualName} 
    setNewManualOrgId={setNewManualOrgId} 
    setShowAddManualModal={setShowAddManualModal} 
    />

    {/* Confirmation Modal for Reset */}
    <Modal show={showResetConfirmModal} onHide={() => setShowResetConfirmModal(false)}>
      <Modal.Header closeButton style={{backgroundColor:'#173c53',color:'white'}}>
        <Modal.Title>Bekräfta återställning</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{backgroundColor:'#fffaf5'}}>Är du säker på att du vill återställa alla ändringar?</Modal.Body>
      <Modal.Footer style={{backgroundColor:'#fffaf5'}}>
        <button className="btn button-cancel" onClick={() => setShowResetConfirmModal(false)}>
          Avbryt
        </button>
        <button className="btn" onClick={handleConfirmReset}>
          Återställ
        </button>
      </Modal.Footer>
    </Modal>

    {/* Confirmation Modal for Sending Emails */}
    <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)}>
      <Modal.Header closeButton style={{backgroundColor:'#173c53',color:'white'}}>
        <Modal.Title>Bekräfta</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{backgroundColor:'#fffaf5'}}>Är du säker på att du vill skicka e-post till valda medlemmar?</Modal.Body>
      <Modal.Footer style={{backgroundColor:'#fffaf5'}}>
        <button className="btn button-cancel" onClick={() => setShowConfirmModal(false)} disabled={isSendingEmails}>
          Avbryt
        </button>
        <button className="btn" onClick={handleConfirmSend} disabled={isSendingEmails}>
          {isSendingEmails ? (
            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
          ) : (
            "Bekräfta"
          )}
        </button>
      </Modal.Footer>
    </Modal>

    {/* Success Modal */}
    <Modal show={showSuccessModal} onHide={handleClose} centered>
      <Modal.Header closeButton style={{backgroundColor:'#173c53',color:'white'}}>
        <Modal.Title className="w-100 text-center">E-post skickat!</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{backgroundColor:'#fffaf5'}}>
        <div
          className="confirmation-box"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FontAwesomeIcon icon={faCheckCircle} size="6x" color="#28a745" style={{ margin: "20px 0" }} />
          <p>E-post har skickats till valda medlemmar!</p>
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center" style={{backgroundColor:'#fffaf5'}}>
        <button className="btn button-cancel" onClick={handleClose}>
          Stäng
        </button>
      </Modal.Footer>
    </Modal>

    {/* Error Modal */}
    <Modal show={errorModalVisible} onHide={() => setErrorModalVisible(false)}>
      <Modal.Header closeButton style={{backgroundColor:'#173c53',color:'white'}}>
        <Modal.Title>Fel</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{backgroundColor:'#fffaf5'}}>
        Ett fel uppstod vid försök att skicka e-post. Kontrollera din anslutning eller försök igen senare.
      </Modal.Body>
      <Modal.Footer style={{backgroundColor:'#fffaf5'}}>
        <button className="btn button-cancel" onClick={() => setErrorModalVisible(false)}>
          Stäng
        </button>
      </Modal.Footer>
    </Modal>

    <Modal show={showDateModal} onHide={handleCancelDateChange} centered>
      <Modal.Header closeButton style={{backgroundColor:'#173c53',color:'white'}}>
        <Modal.Title>Välj Period</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{backgroundColor:'#fffaf5'}}>
        <p style={{ textAlign: "center", marginBottom: "15px" }}>
          Välj start och slut på perioden för granskningen av leverantören. Perioden kommer sträcka sig från start till
          slutmånad.
        </p>

        <div style={{ display: "flex", justifyContent: "center", gap: "40px" }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <label>Startmånad</label>
            <MonthPicker selectedDate={tempStartDate} onDateChange={handleStartDateChange} loading={loading} />
          </div>

          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <label>Slutmånad</label>
            <MonthPicker
              selectedDate={tempEndDate}
              onDateChange={handleEndDateChange}
              loading={loading}
              minDate={tempStartDate}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{backgroundColor:'#fffaf5'}}>
        <button className="btn button-cancel" onClick={handleCancelDateChange}>
          Avbryt
        </button>
        <button className="btn" onClick={handleConfirmDateChange}>
          Bekräfta
        </button>
      </Modal.Footer>
    </Modal>

    <Modal show={showPhoneConfirmModal} onHide={() => setShowPhoneConfirmModal(false)}>
  <Modal.Header closeButton style={{backgroundColor:'#173c53',color:'white'}}>
    <Modal.Title>Bekräfta</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{backgroundColor:'#fffaf5'}}>
    Är du säker på att du vill skapa telefongranskningar för {selectedMembers.length} valda kund
    {selectedMembers.length !== 1 ? "er" : ""}?
  </Modal.Body>
  <Modal.Footer style={{backgroundColor:'#fffaf5'}}>
    <button
      className="btn button-cancel"
      onClick={() => setShowPhoneConfirmModal(false)}
      disabled={isCreatingPhoneReviews}
    >
      Avbryt
    </button>
    <button
      className="btn"
      onClick={handleCreatePhoneReviews}
      disabled={isCreatingPhoneReviews}
    >
      {isCreatingPhoneReviews ? (
        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
      ) : (
        "Bekräfta"
      )}
    </button>
  </Modal.Footer>
</Modal>
<Modal show={showPhoneSuccessModal} onHide={handleClose} centered>
  <Modal.Header closeButton style={{backgroundColor:'#173c53',color:'white'}}>
    <Modal.Title className="w-100 text-center">Telefongranskningar skapade!</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{backgroundColor:'#fffaf5'}}>
    <div
      className="confirmation-box"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <FontAwesomeIcon icon={faCheckCircle} size="6x" color="#28a745" style={{ margin: "20px 0" }} />
      <p>Telefongranskningar har skapats för valda kunder.</p>
    </div>
  </Modal.Body>
  <Modal.Footer className="justify-content-center">
    <button className="btn button-cancel" onClick={handleClose}>
      Stäng
    </button>
  </Modal.Footer>
</Modal>
<Modal show={phoneErrorModalVisible} onHide={() => setPhoneErrorModalVisible(false)}>
  <Modal.Header closeButton style={{backgroundColor:'#173c53',color:'white'}}
>
    <Modal.Title>Fel</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{backgroundColor:'#fffaf5'}}>
    Ett fel uppstod när telefongranskningarna skulle skapas.
  </Modal.Body>
  <Modal.Footer style={{backgroundColor:'#fffaf5'}}>
    <button className="btn button-cancel" onClick={() => setPhoneErrorModalVisible(false)}>
      Stäng
    </button>
  </Modal.Footer>
</Modal>
  </div>
);

};

export default ContactMembersPage;
